import moment from 'moment-timezone';
import { OFFLINE_DRAFT_PREFIX } from '@/util/constants';

export const getLocationCountries = locations =>
  locations.reduce((acc, l) => {
    if (acc.indexOf(l.countryCode) === -1) acc.push(l.countryCode);
    return acc;
  }, []);

export const filterCountriesByLocations = (countries, locations) =>
  countries.filter(c => getLocationCountries(locations).indexOf(c.value) >= 0);

export function apiToLocalDate(momentObj) {
  if (!momentObj) {
    return null;
  }

  let obj = momentObj;
  if (obj !== null && typeof obj !== 'object') {
    obj = moment(momentObj);
  }

  return new Date(
      obj.year(),
      obj.month(),
      obj.date(),
      obj.hours(),
      obj.minutes(),
      obj.seconds(),
  );
}

export function localDateToApi(dateObj) {
  if (!dateObj) {
    return null;
  }

  return moment()
    .year(dateObj.getFullYear())
    .month(dateObj.getMonth())
    .date(dateObj.getDate())
    .hours(dateObj.getHours())
    .minutes(dateObj.getMinutes())
    .seconds(dateObj.getSeconds())
    .milliseconds(0);
}

// Taken from https://stackoverflow.com/a/5997959
export function findUrlsInText(text) {
  const source = (text || '').toString();
  const urlArray = [];
  let matchArray;

  // Regular expression to find FTP, HTTP(S) and email URLs.
  const regexToken = /(((ftp|https?):\/\/)[-\w@:%_+.~#?,&//=]+)|((mailto:)?[_.\w-]+@([\w][\w-]+\.)+[a-zA-Z]{2,3})/g;

  // Iterate through any URLs in the text.
  matchArray = regexToken.exec(source);
  while (matchArray !== null) {
    const token = matchArray[0];
    urlArray.push(token);
    matchArray = regexToken.exec(source);
  }

  return urlArray;
}

export function checkOnlineStatus() {
  return window.navigator.onLine;
}

export function getDraftOnlineStatus(draftId) {
  // true - online, false - offline
  return draftId.toString().indexOf(OFFLINE_DRAFT_PREFIX) === -1;
}

export function checkStorage() {
  return 'storage' in navigator;
}

export function checkServiceWorker() {
  return 'serviceWorker' in navigator && window.isSecureContext;
}

export function checkLocalStorage() {
  return 'localStorage' in window;
}

export function checkIndexedDB() {
  const d = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
  return !!d;
}

export function checkCacheStorage() {
  return 'caches' in window;
}

export function isOfflineModeSupported() {
  return checkServiceWorker()
         && checkLocalStorage()
         && checkIndexedDB()
         && checkStorage()
         && checkCacheStorage();
}



// WEBPACK FOOTER //
// ./src/util/helper.js